export default __webpack_public_path__ + "locales/sr-Latn-RS/Payments.json?hash=f650a4a921804b982949b8c01a84963d";